/**
 *  工具方法
 */
'use strict';
let ua,
    fn = {};
fn.strategySetUA = (strategy, _this, success, done) => {
    let i, reg, flag;
    for (i in strategy) {
        if (Object.prototype.hasOwnProperty.call(strategy, i)) {
            reg = new RegExp(strategy[i], 'ig');
            _this[i] = flag = reg.test(ua);
            if (flag) {
                success(i);
            }
        }
    }
    done();
};

fn.getUA = () => {
    const sysStrategy = {
            android: 'android',
            ios: '(?:ipad|ipod|iphone)'
        },
        appStrategy = {
            mmq: 'mmq/',
            pregnancyhelper: 'pregnancyhelper/',
            gzq: 'gzq/',
            gzm: 'gzm/',
            record: 'recordapp/',
            mmgoods: 'mmgoods/'
        },
        wx = '^(?!.*wxwork).*micromessenger',
        wxwork = 'wxwork',
        sysVerStrategy = ' *([0-9.]*)',
        iosSysVerStrategy = 'OS ([0-9.]*)',
        appVerStrategy = '([0-9.]*)',
        app = {
            android: false,
            ios: false,
            mmq: false,
            pregnancyhelper: false,
            gzq: false,
            gzm: false,
            mmgoods: false,
            mamaApp: false,
            app: '',
            appVer: '0',
            sys: '',
            sysVer: '0',
            wx: false,
            wxwork: false
        };
    let mamaAppStrategy = '';
    for (const k in appStrategy) {
        if (mamaAppStrategy) {
            mamaAppStrategy += `|${appStrategy[k]}`;
        } else {
            mamaAppStrategy += `${appStrategy[k]}`;
        }
    }
    appStrategy.mamaApp = mamaAppStrategy;

    ua = navigator.userAgent;

    fn.strategySetUA(
        appStrategy,
        app,
        function (i) {
            if (i !== 'mamaApp') {
                app.app = i;
            }
        },
        function () {
            if (app.app) {
                const reg = new RegExp(appStrategy[app.app] + appVerStrategy, 'ig');
                if (reg.test(ua)) {
                    app.appVer = RegExp['$1'];
                }
            }
        }
    );

    fn.strategySetUA(
        sysStrategy,
        app,
        function (i) {
            app.sys = i;
        },
        function () {
            if (app.sys) {
                let reg = new RegExp(sysStrategy[app.sys] + sysVerStrategy, 'ig');
                if (reg.test(ua)) {
                    app.sysVer = RegExp['$1'];
                }
                if (app.ios) {
                    reg = new RegExp(iosSysVerStrategy, 'ig');
                    if (reg.test(ua)) {
                        app.sysVer = RegExp['$1'];
                    }
                }
            }
        }
    );
    app.wx = new RegExp(wx, 'ig').test(ua);
    app.wxwork = new RegExp(wxwork, 'ig').test(ua);

    return app;
};

/**
 * fixMethods
 */
fn.fixMethods = () => {
    let i, fixMethods;
    if (!window.android) {
        window.android = {};
    }
    fixMethods = fn.fixMethods;
    for (i in fixMethods) {
        if (Object.prototype.hasOwnProperty.call(fixMethods, i)) {
            fixMethods[i]();
        }
    }
};

/**
 * fix setNavTitle
 */
fn.fixMethods.setNavTitle = () => {
    window.android.setNavTitle = option => {
        if (option) {
            option = JSON.parse(option);
        }
        document.title = option.title;
    };
};

/**
 * 简易二次确认框 confirm
 */
fn.confirm = function (option = {}) {
    let oConfirm = document.getElementById('mjssdkConfirm');
    if (oConfirm) {
        document.body.removeChild(oConfirm);
    }
    const tpl = `
        <div class="mjssdk-confirm ${option.className ? option.className : ''}">
            <div class="mjssdk-confirm-mask"
                 style="position: fixed; top: 0; bottom: 0; left: 0; right: 0;  z-index: 9999; background: rgba(0,0,0,0.5);"></div>
            <div class="mjssdk-confirm-content"
                 style="position: fixed; right: 55px; left: 55px; z-index: 9999; background: #fff; top: 50%; transform: translate(0, -50%); border-radius: 20px; padding:0 35px;">
                <h2 class="mjssdk-confirm-title"
                    style="font-size: 34px; font-weight: bold; text-align: center; line-height: 1.5;margin: 0;padding: 30px;color:#4b4c50;">${
                        option.title
                    }</h2>
                <div class="mjssdk-confirm-desc" style="font-size: 30px; color:#888; padding:0 55px 50px;">${
                    option.desc
                }</div>
                <div class="mjssdk-confirm-btn" style="text-align: center; padding: 35px 0; font-size: 30px;">
                    <a id="mjssdkConfirmBtnYes" href="javascript:;"
                       style="display: inline-block; line-height: 40px;padding: 15px 50px; margin: 0 30px;border-radius: 100px;color: #fff; background: #ff8994; text-decoration: none;">${
                           option.btn[0] || '确定'
                       }</a>
                    <a id="mjssdkConfirmBtnNo" href="javascript:;"
                       style="display: inline-block; line-height: 40px;padding: 15px 50px; margin: 0 30px; border-radius: 100px;color: #ff8994; background: #fff5f9; text-decoration: none;">${
                           option.btn[1] || '取消'
                       }</a>
                </div>
            </div>
        </div>
    `;
    oConfirm = document.createElement('div');
    oConfirm.innerHTML = tpl;
    oConfirm.id = 'mjssdkConfirm';
    document.body.appendChild(oConfirm);
    const oBtnY = document.getElementById('mjssdkConfirmBtnYes');
    const oBtnN = document.getElementById('mjssdkConfirmBtnNo');
    oBtnY.onclick = function () {
        option.yes();
        document.body.removeChild(oConfirm);
    };
    oBtnN.onclick = function () {
        option.no();
        document.body.removeChild(oConfirm);
    };
};
export default fn;
